(function (Responsys, $, undefined) {
	var shopName;
	var registerEmailAddress = function (form) {
		$.ajax({
			url:$(form).attr("action"),
			type: 'post',
			data: $(form).serialize(),
			dataType: 'jsonp',
			cache:false,
			complete: function(successData){
				$(form).find("*").remove();
				$(form).append('<label class="thank-you-emailmsg" style="margin: 0;">Thank you for subscribing to ' + shopName + '</label>');
				$(form).parent().css('marginTop', 0);
				setTimeout(function() {
					//fancy box close
					$.fancybox.close();
				}, 1500);
			} //end success
		}); //end ajax
		return false;
	};

	var validate = function (e, form) {
		e.preventDefault();
		var email = $(form).find("input[name~='EMAIL_ADDRESS_']").val();
		var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		if (regex.test(email)) {
			registerEmailAddress($(form));
		} else {
			$(form).find("input[name~='EMAIL_ADDRESS_']").addClass("error")
			.val("Please enter a valid email address")
			.focus(function() {
				$(form).find("input[name~='EMAIL_ADDRESS_']").removeClass("error");
			});
		}
	};

	var bindUIActions = function () {
		$("form[name='emailsignupbox']").on("submit", function(e) {
			validate(e, $(this));
		});
		$("form[name='emailsignupbox'] input[name~='EMAIL_ADDRESS_']").focus(function() {
			if ($(this).val() == "Enter Your Email" || $(this).val() == "Please enter a valid email address"){
				$(this).val("");
			}
		});
		$("form[name='emailsignupbox'] input[name~='EMAIL_ADDRESS_']").blur(function() {
			if ($(this).val().trim() === "") {
				$(this).val("Enter Your Email");
			}
		});
	};

	Responsys.init = function (storeName) {
		shopName = storeName;
		bindUIActions();
	};

}(window.Responsys = window.Responsys || {}, jQuery));
